<div class="text-center p-5" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-fw fa-3x"></i>
</div>
<div class="pb-3" style="width: 700px; max-width: 100% !important" *ngIf="!loading">
  <h6>{{ event_obj.name }}</h6>
  <div style="font-size: 93% !important">
    <table style="font-size: 93% !important" class="pl-5">
      <tbody>
        <tr>
          <th class="px-3" scope="row">Date/Time:</th>
          <td>{{ title }}</td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Duration:</th>
          <td>{{ time_difference }}</td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Reminder:</th>
          <td>
            <span *ngIf="event_obj.formatted_reminder" [innerHTML]="event_obj.formatted_reminder | safeHtml"></span>
            <span *ngIf="event_obj.formatted_reminder && event_obj.reminder_id">&nbsp;</span>
            <span *ngIf="event_obj.reminder_id">
              <a href="#" (click)="$event.preventDefault(); openReminder(event_obj.reminder_id)">View</a>
            </span>
            <span *ngIf="!event_obj.formatted_reminder">Not set</span>
          </td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Repeat:</th>
          <td>
            <span *ngIf="event_obj.rruleFormat">{{ event_obj.rruleFormat }}</span>
            <span *ngIf="!event_obj.rruleFormat">Does not repeat</span>
          </td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Matter:</th>
          <td>
            <span *ngIf="event_obj.matter_id">
              <a [routerLink]="'/matters/' + event_obj.matter_id">{{ event_obj.matter_number }} - {{ event_obj.matter_name }}</a>
            </span>
          </td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Address:</th>
          <td>
            <span *ngIf="event_obj.address">
              @&nbsp;<b>{{ event_obj.address_name }}</b
              >&nbsp;
              <a [href]="'http://local.google.com/maps?daddr=' + event_obj.address" target="_blank">{{ event_obj.address }}</a>
            </span>
          </td>
        </tr>
        <tr *ngIf="event_obj.phone">
          <th class="px-3" scope="row">Phone:</th>
          <td>
            <span>
              <a appPhoneCallBilling [phoneCallContactName]="event_obj.contact_name || ''" [href]="'tel:' + event_obj.phone" title="Call {{ event_obj.phone }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ event_obj.phone }}</a>
            </span>
          </td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Created At:</th>
          <td>
            <span *ngIf="event_obj.created_at"> {{ event_obj.created_at }}&nbsp;by&nbsp; </span>
            <span *ngIf="event_obj.created_by_link">
              <a [ngStyle]="{ color: event_obj.created_by_color_code }" [routerLink]="event_obj.created_by_link">{{ event_obj.created_by_person_name }}</a>
            </span>
          </td>
        </tr>
        <tr>
          <th class="px-3" scope="row">Updated At:</th>
          <td>
            <span *ngIf="event_obj.updated_at"> {{ event_obj.updated_at }}&nbsp;by&nbsp; </span>
            <span *ngIf="event_obj.updated_by_link">
              <a [ngStyle]="{ color: event_obj.updated_by_color_code }" [routerLink]="event_obj.updated_by_link">{{ event_obj.updated_by_person_name }}</a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="event_obj.private">
      <strong>This is a private event</strong>
    </div>
    <div *ngIf="event_obj.matter_user_attendees.length > 0">
      <br />
      <h6>User Attendees</h6>
      <div *ngFor="let attendee of event_obj.matter_user_attendees">
        <a [ngStyle]="{ color: attendee.color }" [routerLink]="attendee.link">{{ attendee.name }}</a>
      </div>
    </div>
    <div class="py-1"></div>
    <div *ngIf="event_obj.involvement_attendees.length > 0">
      <h6>Involvement Attendees</h6>
      <div *ngFor="let attendee of event_obj.involvement_attendees">
        <a [routerLink]="attendee.link">{{ attendee.name }}</a>
      </div>
    </div>
    <br />
    <div>
      <strong>Description</strong><br />
      {{ event_obj.notes }}
    </div>
  </div>
</div>
